// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2ubKT","productName":"Table_productName__1HTWJ"};